module.exports = __webpack_public_path__ + "static/media/foul-play-feature-banner-sm@2x.4ba81755.jpg";